"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * MyBuy Backend API
 * ## Release Notes  ### v0.0.1  Work in progress
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentPlanDetailsToJSON = exports.PaymentPlanDetailsFromJSONTyped = exports.PaymentPlanDetailsFromJSON = void 0;
var runtime_1 = require("../runtime");
var _1 = require("./");
function PaymentPlanDetailsFromJSON(json) {
    return PaymentPlanDetailsFromJSONTyped(json, false);
}
exports.PaymentPlanDetailsFromJSON = PaymentPlanDetailsFromJSON;
function PaymentPlanDetailsFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'isNegative': !(0, runtime_1.exists)(json, 'isNegative') ? undefined : json['isNegative'],
        'amount': !(0, runtime_1.exists)(json, 'amount') ? undefined : (0, _1.AmountFromJSON)(json['amount']),
        'documentNo': !(0, runtime_1.exists)(json, 'documentNo') ? undefined : json['documentNo'],
        'unifiedInvoiceId': !(0, runtime_1.exists)(json, 'unifiedInvoiceId') ? undefined : json['unifiedInvoiceId'],
        'date': !(0, runtime_1.exists)(json, 'date') ? undefined : json['date'],
        'bookingText': !(0, runtime_1.exists)(json, 'bookingText') ? undefined : json['bookingText'],
    };
}
exports.PaymentPlanDetailsFromJSONTyped = PaymentPlanDetailsFromJSONTyped;
function PaymentPlanDetailsToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'isNegative': value.isNegative,
        'amount': (0, _1.AmountToJSON)(value.amount),
        'documentNo': value.documentNo,
        'unifiedInvoiceId': value.unifiedInvoiceId,
        'date': value.date,
        'bookingText': value.bookingText,
    };
}
exports.PaymentPlanDetailsToJSON = PaymentPlanDetailsToJSON;
//# sourceMappingURL=PaymentPlanDetails.js.map